import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './Promocion.css';
import './Formulario.css';
import botellasImage from '../assets/images/botellas.png';
import footerImage from '../assets/images/footer.png';
import cartelImage from '../assets/images/cartel.png';

const API_ENDPOINT = 'https://k3jt3d52je.execute-api.us-east-1.amazonaws.com/prod/redbull';

const CADENAS_VALIDAS = [
  'mckiominotucuman',
  'natalyquilpelabanda',
  'autoservicioscapominotucuman',
  'elpuestominotucuman',
  'elmarquesminotucuman',
  'draxxominosantafe',
  'saynomoreminosantafe',
  'marketayaminorosario',
  'pingüino',
  'siete27',
  'altotejeda',
  'puntog',
  'drinks',
  'todo',
  'dinastia',
  'axionbariloche',
  'mercadodellago',
  'comercialneuquina',
  'amelia',
  'ecomarket',
  'rionahueveshelllacolina',
  'pumaglobaloil',
  'kioscosyes',
  'kioscoskiobox',
  'aspret',
  'centralbebidas',
  'multimarket',
  'kioskosonestop',
];

const Promocion = ({ onShowTerminos }) => {
  const { cadena } = useParams();
  const cadenaValida = cadena && CADENAS_VALIDAS.includes(cadena.toLowerCase());

  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  
  // Estado del formulario
  const [formData, setFormData] = useState({
    email: '',
    nombreApellido: '',
    dni: '',
    telefono: '',
    numeroTicket: '',
    ticketFile: null,
    compressedImageBase64: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpiar mensajes de estado al cambiar campos
    if (submitStatus) {
      setSubmitStatus(null);
      setSubmitMessage('');
    }
  };

  const compressImage = (file, maxWidth = 1024, quality = 0.8) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // Redimensionar si es necesario
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // Convertir a base64 con compresión
          const mimeType = file.type || 'image/jpeg';
          const compressedBase64 = canvas.toDataURL(mimeType, quality);
          
          resolve(compressedBase64);
        };

        img.onerror = (error) => reject(error);
      };

      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Limpiar mensajes de estado al cambiar archivo
    if (submitStatus) {
      setSubmitStatus(null);
      setSubmitMessage('');
    }

    // Comprimir la imagen si es muy grande
    try {
      // Comprimir siempre las imágenes para optimizar el tamaño
      if (file.size > 100 * 1024) { // Si es mayor a 100KB, comprimir
        const compressedBase64 = await compressImage(file);
        // Crear un objeto File simulado para mantener el nombre original
        const compressedFile = new File([file], file.name, { type: file.type });
        setFormData(prev => ({
          ...prev,
          ticketFile: compressedFile,
          compressedImageBase64: compressedBase64
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          ticketFile: file,
          compressedImageBase64: null
        }));
      }
    } catch (error) {
      console.error('Error al comprimir imagen:', error);
      // Si falla la compresión, usar la imagen original
      setFormData(prev => ({
        ...prev,
        ticketFile: file,
        compressedImageBase64: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!aceptaTerminos) {
      setSubmitStatus('error');
      setSubmitMessage('Por favor, acepta los términos y condiciones antes de enviar el formulario.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);
    setSubmitMessage('');

    // Validar que la imagen esté presente
    if (!formData.ticketFile) {
      setSubmitStatus('error');
      setSubmitMessage('Por favor, selecciona una imagen del ticket antes de enviar el formulario.');
      setIsSubmitting(false);
      return;
    }

    try {
      // Convertir imagen a base64 (usar la comprimida si existe)
      let ticketImageBase64 = null;
      if (formData.compressedImageBase64) {
        // Usar la imagen ya comprimida
        ticketImageBase64 = formData.compressedImageBase64;
      } else {
        // Comprimir siempre para optimizar
        ticketImageBase64 = await compressImage(formData.ticketFile);
      }

      // Preparar datos para enviar
      const payload = {
        email: formData.email.trim(),
        nombreApellido: formData.nombreApellido.trim(),
        dni: formData.dni.trim(),
        telefono: formData.telefono.trim(),
        numeroTicket: formData.numeroTicket.trim(),
        ticketImage: ticketImageBase64,
        cadena: cadena.toLowerCase()
      };

      // Hacer POST al endpoint
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSubmitStatus('success');
        setSubmitMessage('¡Formulario enviado exitosamente!');
        // Limpiar formulario después de éxito
        setFormData({
          email: '',
          nombreApellido: '',
          dni: '',
          telefono: '',
          numeroTicket: '',
          ticketFile: null,
          compressedImageBase64: null
        });
        // Resetear el input de archivo
        const fileInput = document.getElementById('ticketFile');
        if (fileInput) {
          fileInput.value = '';
        }
        // Desmarcar términos
        setAceptaTerminos(false);
      } else {
        setSubmitStatus('error');
        // Manejar error específico de ticket duplicado
        if (response.status === 409) {
          setSubmitMessage(data.message || 'Este número de ticket ya ha sido registrado. Cada ticket solo puede ser usado una vez.');
        } else {
          setSubmitMessage(data.message || data.error || 'Error al enviar el formulario. Por favor intenta nuevamente.');
        }
      }
    } catch (error) {
      console.error('Error al enviar formulario:', error);
      setSubmitStatus('error');
      setSubmitMessage('Error de conexión. Por favor verifica tu internet e intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!cadenaValida) {
    return (
      <div className="promocion-container">
        <div className="cans-section">
          <img src={botellasImage} alt="Red Bull Botellas" className="botellas-image" />
        </div>
        <div className="middle-section" style={{ textAlign: 'center', padding: '40px 20px' }}>
          <img src={cartelImage} alt="PROMOCIÓN MINI REFUEL" className="promo-title-image" />
          <div className="submit-message submit-message-error" style={{ marginTop: '30px', fontSize: '16px' }}>
            {cadena
              ? `El punto de venta "${cadena}" no es válido para esta promoción.`
              : 'Acceso inválido. Por favor utilizá el enlace que te fue proporcionado.'}
          </div>
        </div>
        <div className="footer-section">
          <div className="footer-white-box"></div>
          <img src={footerImage} alt="Footer" className="footer-image" />
        </div>
      </div>
    );
  }

  return (
    <div className="promocion-container">
      {/* Top Section - Red Bull Cans */}
      <div className="cans-section">
        <img src={botellasImage} alt="Red Bull Botellas" className="botellas-image" />
      </div>

      {/* Middle Section */}
      <div className="middle-section">
        <img src={cartelImage} alt="PROMOCIÓN MINI REFUEL" className="promo-title-image" />
        
        <div className="terms-section">
          <div className="terms-checkbox-container">
            <label className="terms-checkbox">
              <input
                type="checkbox"
                checked={aceptaTerminos}
                onChange={(e) => setAceptaTerminos(e.target.checked)}
              />
              <span className="terms-text">ACEPTO</span>
            </label>
            <span className="terms-separator"> </span>
            <button 
              type="button"
              className="terms-link-button"
              onClick={(e) => { 
                e.preventDefault(); 
                e.stopPropagation();
                if (onShowTerminos) {
                  onShowTerminos();
                }
              }}
            >
              TÉRMINOS Y CONDICIONES
            </button>
          </div>
        </div>

        {/* Form Section */}
        <div className="formulario-content" style={{ width: '100%', marginTop: '10px' }}>
          <form onSubmit={handleSubmit} className="formulario-form">
            <div className="form-field">
              <label className="form-label">E-MAIL</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-input"
                disabled={!aceptaTerminos}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">NOMBRE Y APELLIDO</label>
              <input
                type="text"
                name="nombreApellido"
                value={formData.nombreApellido}
                onChange={handleInputChange}
                className="form-input"
                disabled={!aceptaTerminos}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">DNI</label>
              <input
                type="tel"
                name="dni"
                value={formData.dni}
                onChange={handleInputChange}
                className="form-input"
                inputMode="numeric"
                pattern="[0-9]*"
                disabled={!aceptaTerminos}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">TELÉFONO DE CONTACTO</label>
              <input
                type="tel"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                className="form-input"
                disabled={!aceptaTerminos}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">NÚMERO DE TICKET</label>
              <input
                type="text"
                name="numeroTicket"
                value={formData.numeroTicket}
                onChange={handleInputChange}
                className="form-input"
                disabled={!aceptaTerminos}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">CARGA TU TICKET</label>
              <div className="file-upload-container">
                <input
                  type="file"
                  id="ticketFile"
                  name="ticketFile"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="file-input"
                  disabled={!aceptaTerminos}
                />
                <label 
                  htmlFor="ticketFile" 
                  className="file-upload-button"
                  style={{ 
                    opacity: !aceptaTerminos ? 0.5 : 1,
                    cursor: !aceptaTerminos ? 'not-allowed' : 'pointer',
                    pointerEvents: !aceptaTerminos ? 'none' : 'auto'
                  }}
                >
                  ADJUNTAR FOTO
                </label>
                {formData.ticketFile && (
                  <span className="file-name">{formData.ticketFile.name}</span>
                )}
              </div>
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting || !aceptaTerminos}
            >
              {isSubmitting ? 'ENVIANDO...' : 'ENVIAR FORMULARIO'}
            </button>

            {/* Mensajes de estado */}
            {submitStatus === 'success' && (
              <div className="submit-message submit-message-success">
                {submitMessage}
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="submit-message submit-message-error">
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>

      {/* Bottom Section - Footer */}
      <div className="footer-section">
        <div className="footer-white-box"></div>
        <img src={footerImage} alt="Footer" className="footer-image" />
      </div>
    </div>
  );
};

export default Promocion;
